/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Move_Line_DownInputs */

const en_shortcut_keys_desc_move_line_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shift line forward to the beginning of the next Event`)
};

const fr_shortcut_keys_desc_move_line_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer une ligne vers le debut de l'evenement suivant`)
};

const de_shortcut_keys_desc_move_line_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Umschaltlinie wird zum Beginn des nächsten Ereignisses vorgeschoben.`)
};

const it_shortcut_keys_desc_move_line_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta la riga in avanti all'inizio del prossimo evento`)
};

const ru_shortcut_keys_desc_move_line_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместите линию вперед к началу следующего события.`)
};

const es_shortcut_keys_desc_move_line_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazar la línea hacia adelante hasta el comienzo del siguiente evento`)
};

const zh_cn2_shortcut_keys_desc_move_line_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将线向前移动到下一个事件的开始位置`)
};

const ja_shortcut_keys_desc_move_line_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のイベントの先頭まで行を進める`)
};

const hi_shortcut_keys_desc_move_line_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगली घटना की शुरुआत तक लाइन को आगे बढ़ाएं`)
};

const pt_pt2_shortcut_keys_desc_move_line_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Line_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desloque a linha para a frente até o início do próximo evento.`)
};

/**
* | output |
* | --- |
* | "Shift line forward to the beginning of the next Event" |
*
* @param {Shortcut_Keys_Desc_Move_Line_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_move_line_down = /** @type {((inputs?: Shortcut_Keys_Desc_Move_Line_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Move_Line_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_move_line_down(inputs)
	if (locale === "de") return de_shortcut_keys_desc_move_line_down(inputs)
	if (locale === "it") return it_shortcut_keys_desc_move_line_down(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_move_line_down(inputs)
	if (locale === "es") return es_shortcut_keys_desc_move_line_down(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_move_line_down(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_move_line_down(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_move_line_down(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_move_line_down(inputs)
	return en_shortcut_keys_desc_move_line_down(inputs)
});